export let AWCCookiesKeys = /*#__PURE__*/function (AWCCookiesKeys) {
  AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
  AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
  AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
  return AWCCookiesKeys;
}({});
class CookieSchema {
  constructor(key, options) {
    this.key = key;
    this.options = options;
  }
  getAttributes() {
    return this.options;
  }
  getKey() {
    return this.key;
  }
}
export const AllAnalyticsCookies = {
  [AWCCookiesKeys.AWC_TLD_TEST]: new CookieSchema('__awc_tld_test__', {
    expires: 365,
    secure: window.location.protocol === 'https:',
    path: '/'
  }),
  [AWCCookiesKeys.AWC_ANALYTICS_DEBUG]: new CookieSchema('atlassian_analytics_debug', {
    expires: 365,
    secure: window.location.protocol === 'https:',
    path: '/'
  }),
  [AWCCookiesKeys.AJS_ANONYMOUS_ID]: new CookieSchema('ajs_anonymous_id', {
    expires: 365,
    secure: window.location.protocol === 'https:',
    path: '/'
  })
};